module.exports = __webpack_public_path__ + "img/governance@2x.f4cf32c0.png";